import React, { Component } from 'react';
import Button from '../../../../../components/Button';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import Anchor from '../../../../../components/link/Anchor';
import Panel from '../../../../../components/outline/Panel';
import TableTransfer from '../../../../../components/input/TableTransfer';
import { PRODUCT_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import { comparePrePropsAndNextProps } from '../../../../../lib/common';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/recommend/product/models';
import { columns } from './columns';
import './RecommendProductSaveItemList.scss';

class RecommendProductSaveItemList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const {
      recommendProductItemList,
      getRecommendProductItemList,
      selectRecommendProductItemList,
      onDragEndSelectRecommendProductItemList,
      getRecommendProductItemListExcelDownload,
      getSelectedRecommendProductItemListExcelDownload,
      setRecommendProductItemListExcelUpload,
      mainProductCategorySelectList,
      subProductCategorySelectList,
      getProductSubCategoryList,
    } = this.props;
    const { itemList, selectedItemList } = recommendProductItemList;

    return (
      <Panel className="recommend-product-save-item-list">
        <div className="panel-header">
          <div className="title">추천 상품 아이템 리스트</div>
        </div>

        <div className="panel-body">
          <TableTransfer
            dataSource={itemList.list}
            operations={['연결', '해제']}
            leftTitle="상품 리스트"
            rightTitle="선택된 상품 리스트"
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  mainProductCategorySelectList,
                  subProductCategorySelectList,
                  getProductSubCategoryList,
                  isFilter: true,
                }),
              headInfo: (
                <div className="recommend-product-item-head">
                  <div className="excel-button-list">
                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={getRecommendProductItemListExcelDownload}
                    />
                  </div>
                </div>
              ),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
              getList: getRecommendProductItemList,
              pagination: itemList.pagination,
              sortOption: itemList.sortOption,
              filterOption: itemList.filterOption,
              initialOption: {
                filterOption: RECOMMEND_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
                sortOption: RECOMMEND_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
                pagination: _LIST_PAGINATION_MODEL,
              },
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getProductSubCategoryList,
                }),
              headInfo: (
                <div className="selected-recommend-product-item-head">
                  <div className="selected-recommend-product-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>

                  <div className="excel-button-list">
                    <Anchor
                      text="상품 업로드 템플릿"
                      isUnderLine
                      color="primary"
                      href={PRODUCT_UPLOAD_TEMPLATE_XLSX_URL}
                      target="_blank"
                    />

                    <ExcelUploadForm
                      onChange={(file) => setRecommendProductItemListExcelUpload(file)}
                      btnText="상품 엑셀 업로드"
                    />

                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={getSelectedRecommendProductItemListExcelDownload}
                    />
                  </div>
                </div>
              ),
              list: selectedItemList.list,
              canDrag: true,
              onDragEnd: (newList) => onDragEndSelectRecommendProductItemList(newList.list),
            }}
            onChange={(action, moveIdList) => selectRecommendProductItemList(action, moveIdList)}
          />
        </div>
      </Panel>
    );
  }
}

export default RecommendProductSaveItemList;
